import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/Home'
import About from '@/About'
import Service from '@/Service'
import Cases from '@/Cases'
import Contact from '@/Contact'
import News from '@/News'
import Pro1 from '@/pruduct1'
import Pro2 from '@/pruduct2'
import Pro3 from '@/pruduct3'
import Pro4 from '@/pruduct4'
import Pro5 from '@/pruduct5'
import Coupon from '@/Coupon'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    }, {
      path: '/about',
      name: 'About',
      component: About
    }, {
      path: '/service',
      name: 'Service',
      component: Service
    }
    , {
      path: '/cases',
      name: 'Cases',
      component: Cases
    }
    , {
      path: '/contact',
      name: 'Contact',
      component: Contact
    }, {
      path: '/news',
      name: 'News',
      component: News
    }, { path: '/pruduct1', name: 'Pro1', component: Pro1 },
    { path: '/pruduct2', name: 'Pro2', component: Pro2 },
    { path: '/pruduct3', name: 'Pro3', component: Pro3 },
    { path: '/pruduct4', name: 'Pro4', component: Pro4 },
    { path: '/pruduct5', name: 'Pro5', component: Pro5 },
    { path: '/coupon', name: 'Coupon', component: Coupon },



  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js